import { danger } from '../../../../../utils/brandColors';

export default () => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  cardActionsContainer: { width: '100%' },
  actionIconButtonDelete: { color: danger.main },
  eventTemplateEditorTabs: { marginBottom: '1rem' },
  formSection: {
    marginBottom: '2rem',
    width: '100%',
  },
});
